import React from 'react';
import '../css/FreemiumCrestest.css';
import { FaArrowRight } from 'react-icons/fa';

const NonSchoolKirnavali = () => {
  return (
    <section className="freemium-band-section">
      <div className="freemium-band-overlay"></div>
      
      <div className="container freemium-band-container">
        <div className="freemium-band-content">
          <div className="freemium-band-text">
            <span className="freemium-band-badge">Kirnavali</span>
            <h1 className="nonschool-band-title">
              Don't have a school's referral code? Join as an individual and win exciting goodies and national-level recognition.
            </h1>
          </div>
          
          <a 
            href="https://kirnavali-staging.crestestlearning.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="freemium-band-btn"
          >
            <span>Join as Individual</span>
            {/* <FaArrowRight className="arrow-icon" /> */}
          </a>
        </div>
      </div>
    </section>
  );
};

export default NonSchoolKirnavali;